<template>
  <div>
    <v-navigation-drawer v-model="drawer"
                         app
                         right
                         temporary
                         touchless
                         class="fin-help-center"
                         style="z-index: 301"
                         :width="width"
                         :stateless="videoDialog||isLexiconVisible"
                         clipped
                         :color="$finColors.accentBlue">
      <fin-data-loader :resolver="loadData"
                       v-if="drawer"
                       overlay>
        <template #content>
          <v-container v-resize="resize"
                       :class="`fin-help-center-content-wrapper ${$vuetify.breakpoint.xs ? 'pa-6' : 'pa-12'}`"
                       style="height: inherit; overflow: hidden; min-width: 100%"
                       v-if="contextHelp">
            <v-btn class="close"
                   icon
                   large
                   @click="closeHelpCenter()"
                   style="float: right;">
              <v-icon class="nav-icon"

                      color="white">
                icon-close
              </v-icon>
            </v-btn>
            <v-row class="my-0 py-0"
                   v-if="contextHelp">
              <v-col>
                <h3 class="d-flex align-center mb-0" style="text-transform: uppercase">
                  <v-icon>icon-academy</v-icon>
                  Academy
                </h3>
              </v-col>
            </v-row>
            <v-row class="my-0 py-0">
              <v-col class="my-0 py-0">
                <h4>{{ contextHelp.title }}</h4>
              </v-col>
            </v-row>
            <v-row class="py-0">
              <v-col class="pt-0 content-wrapper">
                <reference-handler @entryClicked="entryClicked">
                  <div v-for="(content,index) in contents"
                       :key="index">
                    <Content :slice="content"/>
                  </div>
                </reference-handler>
              </v-col>
            </v-row>

            <v-row>
              <v-col v-for="(tour, index) in tours"
                     :key="index"
                     cols="auto">
                <v-btn @click="startTour(`${index}`)"
                       dark
                       outlined
                       large
                       class="btn-start-tour px-6">
                  {{ tour.primary.label }}
                </v-btn>
              </v-col>
              <v-col cols="auto">
                <v-btn @click="openLexicon()"
                       class="fin-lexicon-button px-6"
                       dark
                       outlined
                       large>
                  <v-icon class="mr-1">icon-lexicon</v-icon>
                  finLexikon
                </v-btn>
              </v-col>
            </v-row>
            <v-row v-if="videos && videos.length > 0">
              <v-col>
                <h5 class="mb-2">Passend zum Thema</h5>
                <v-row v-for="(video, index) in videos"
                       :key="index"
                       @click="setSelectedVideo(video.video)">
                  <v-col cols="3">
                    <div class="thumbnail-wrapper">
                      <v-img :src="video.video.thumbnail_url">
                        <template #placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="grey lighten-5"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                      <v-icon class="play-icon">mdi-play-circle-outline</v-icon>
                    </div>
                  </v-col>
                  <v-col class="d-flex align-center">
                    <v-row>
                      <v-col>
                        {{ video.video.title }}<br/>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </template>
      </fin-data-loader>
    </v-navigation-drawer>
    <fin-video-dialog v-model="videoDialog"
                      :src="selectedVideo">
      <div class="video-container" style="display: inline-block; vertical-align: top; width: 100%;">

        <fin-video-secure v-if="selectedVideo"
                          :isApp="isApp">
          <prismic-embed :field="selectedVideo"></prismic-embed>
        </fin-video-secure>
      </div>
    </fin-video-dialog>

    <fin-tour v-for="(tour, index) in tours"
              :key="index"
              :tourID="`${index}`"
              :tourName="tours[index].primary.tour_name[0].text"
              :btnLabel="tour.primary.label"
              :steps="tour.fields"
              @startTour="drawer=false"/>

  </div>
</template>

<script>
import Content from "@/components/common/lexicon/LexiconOverlay/slices/Content"
import LexiconAPI from "@/components/common/lexicon/LexiconAPI"
import FinDataLoader from "@/components/common/DataLoader"
import FinTour from "@/components/common/Tour"
import perfectscrollbar from "fincraft-lib-basics/src/mixins/perfectscrollbar"
import {EventBus} from '@/plugins/fincraft'
import ReferenceHandler from "@/components/common/lexicon/LexiconOverlay/ReferenceHandler"
import AmplitudePush from "@/mixins/AmplitudePush"
import FinVideoDialog from "@/components/common/video/VideoDialog"
import {Capacitor} from '@capacitor/core'


export default {
  name: "finHelpCenter",
  components: {
    FinVideoDialog,
    ReferenceHandler,
    FinTour,
    FinDataLoader,
    Content
  },
  mixins: [perfectscrollbar, AmplitudePush],
  props: {
    /**
     * Optional: Route name
     */
    contextID: {
      type: String,
    }
  },
  data() {
    return {
      drawer: false,
      contextHelp: undefined,
      injectedDoc: null,
      lexiconWidth: '100%',
      showOnlyEntryDesktopWidth: '33%',
      selectedVideo: undefined,
      videoDialog: false,
      videoDialogWidth: "800px",
      isLexiconVisible: false
    }
  },
  computed: {
    isApp() {
      return Capacitor.isNative
    },
    contents() {
      if (!this.contextHelp) {
        return
      }
      return this.contextHelp.body.filter(entry => entry.type === "content") || undefined
    },
    tours() {
      if (!this.contextHelp) {
        return
      }
      return this.contextHelp.body.filter(entry => entry.type === "tour") || undefined
    },
    videos() {
      let result = []
      if (!this.contextHelp) {
        return
      }
      this.contextHelp.body.filter(entry => entry.type === "video").forEach(videoWrapper => {
        videoWrapper.fields.forEach(video => {
          result.push(video)
        })
      })
      return result
    },
    width() {
      let res = undefined
      if (this.$vuetify.breakpoint.mdAndUp) {
        res = this.showOnlyEntryDesktopWidth
      } else if (this.$vuetify.breakpoint.lgAndUp) {
        res = this.showOnlyEntryDesktopWidth
      } else {
        res = this.lexiconWidth
      }
      return res
    },
    loadData() {
      const route = this.contextID || this.$route.name
      return {
        key: 'contextHelp_' + route,
        load: async () => this.injectedDoc || await LexiconAPI.loadContextHelp(route),
        adapt: val => this.contextHelp = this.injectedDoc || val,
      }
    },
  },
  methods: {
    lexiconVisible(val) {
      this.isLexiconVisible = val
    },
    entryClicked(entry) {
      EventBus.$emit('showLexicon', entry?.ref, false)
    },
    openLexicon() {
      this.pushToAmplitude({
        'event': "fincraft_helpcenter",
        'step': "open_lexikon",
        'placement': 'helpcenter_overlay',
        'vue_breakpoint': this.$vuetify.breakpoint.name
      })
      EventBus.$emit("showLexicon", undefined, undefined, true)
    },
    startTour(id) {
      this.pushToAmplitude({
        'event': "fincraft_helpcenter",
        'step': "open_tour",
        'step_choice': id,
        'placement': 'helpcenter_overlay',
        'vue_breakpoint': this.$vuetify.breakpoint.name
      })
      EventBus.$emit("startTour", id)
    },
    setSelectedVideo(videoUrl) {
      this.selectedVideo = videoUrl
      this.pushToAmplitude({
        'event': "fincraft_helpcenter",
        'step': "open_video",
        'step_choice': videoUrl,
        'placement': 'helpcenter_overlay',
        'vue_breakpoint': this.$vuetify.breakpoint.name
      })

      this.$nextTick(() => {
        this.videoDialog = true
      })
    },
    resize() {
      this.$nextTick(() => {
        this.updateScrollbar()
      })
    },
    getScrollElement() {
      return this.$el.querySelector('.fin-help-center .v-navigation-drawer__content')
    },
    wrapInSlice(content) {
      return {
        primary: {
          text: content
        },
        type: 'Content'
      }
    },
    showHelpCenter() {
      this.injectedDoc = null
      this.drawer = true
    },
    injectHelpCenter(doc) {
      this.injectedDoc = doc
      this.drawer = true
    },
    closeHelpCenter() {
      this.drawer = false
    }
  },
  watch: {
    videoDialog(newVal) {
      if (!newVal) {
        this.selectedVideo = undefined
      }
    },
  },
  mounted() {
    EventBus.$on('showHelpCenter',
      this.showHelpCenter
    )
    EventBus.$on('injectHelpCenter',
      this.injectHelpCenter
    )
    EventBus.$on('closeHelpCenter',
      this.closeHelpCenter
    )
    EventBus.$on('lexiconVisible',
      this.lexiconVisible
    )
  },
  beforeDestroy() {
    EventBus.$off('showHelpCenter',
      this.showHelpCenter
    )
    EventBus.$off('injectHelpCenter',
      this.injectHelpCenter
    )
    EventBus.$off('closeHelpCenter',
      this.closeHelpCenter
    )
    EventBus.$off('lexiconVisible',
      this.lexiconVisible
    )
  },
}
</script>


<style lang="scss" scoped>
.fin-help-center {
  &,
  i {
    color: $fin-color-primary-light;
  }

  h3,
  h5 {
    font-size: 1.3em;
    font-weight: 600;
    letter-spacing: 1.17px;
    vertical-align: middle;

    i {
      margin-right: 10px;
      font-size: 1.6em;
    }
  }

  h4 {
    font-size: 1.7em;
    font-weight: 500;
    font-family: $heading-font-family;
  }

  .thumbnail-wrapper {
    position: relative;
  }

  .play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: $fin-color-primary-light;
    opacity: 0.75;
    font-size: 2.5em;
  }

  .content-wrapper {
    line-height: 1.5;
    font-size: 1.1em;
  }

  .fin-lexicon-button {
    width: 100%;
  }

}

.fin-video-dialog {
  z-index: 350;
}

.video-container {
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 0;
  height: 0;
  overflow: hidden;
}

.video-container ::v-deep iframe,
.video-container ::v-deep object,
.video-container ::v-deep embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
